import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      toast.success("Password updated — you can log in now");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-950 to-indigo-950 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <button onClick={() => navigate("/login")} className="text-sm text-slate-500 flex items-center gap-1 mb-6 hover:text-slate-800"><ArrowLeft className="h-4 w-4" /> Back to login</button>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Choose a new password</h1>
        {!token ? (
          <p className="text-slate-500 mt-3">This reset link is missing its token. Request a new one from the login page.</p>
        ) : done ? (
          <p className="text-emerald-600 mt-3">Password updated. Redirecting to login…</p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-3">
            <Input data-testid="reset-password" type="password" placeholder="New password (min 8 characters)" value={pw} onChange={(e) => setPw(e.target.value)} className="h-12" />
            <Input data-testid="reset-confirm" type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-12" />
            <Button type="submit" disabled={busy} data-testid="reset-submit" className="w-full h-12 rounded-full bg-indigo-600 hover:bg-indigo-700 font-semibold">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
